const validPreview = (value) => {
  if (/^data:image\/(png|jpeg|webp);base64,[A-Za-z0-9+/=\s]+$/.test(value)) return true;
  try {
    return new URL(value).protocol === 'https:';
  } catch {
    return false;
  }
};

const restorePreviews = () => {
  document.querySelectorAll('.cart-items__table-row[data-key]').forEach((row) => {
    let thumbnailId = row.dataset.tfsApodThumbnail;
    row.querySelectorAll('.cart-items__properties dt').forEach((label) => {
      if (label.textContent.trim().replace(/:$/, '') !== 'thumbnail-id') return;
      const value = label.nextElementSibling?.textContent.trim();
      if (!/^[a-f0-9-]{36}$/i.test(value || '')) return;
      thumbnailId = value;
      row.dataset.tfsApodThumbnail = value;
      label.parentElement.remove();
    });
    if (!thumbnailId) return;
    let preview;
    try {
      preview = localStorage.getItem(thumbnailId);
    } catch {
      return;
    }
    if (!preview || !validPreview(preview)) return;
    const image = row.querySelector('.cart-items__media img');
    if (!image) return;
    if (image.getAttribute('src') !== preview) image.setAttribute('src', preview);
    if (image.hasAttribute('srcset')) image.removeAttribute('srcset');
    image.style.objectFit = 'contain';
  });

  const countNode = document.querySelector('main [ref="cartItemCount"]');
  const count = countNode ? Number(countNode.textContent.trim()) : document.querySelector('main .cart-page--empty') ? 0 : null;
  if (count === null || !Number.isInteger(count) || count < 0) return;
  const text = count > 0 ? ' (' + count + ')' : '';
  document.querySelectorAll('[data-tfs-cart-count]').forEach((node) => {
    if (node.textContent !== text) node.textContent = text;
  });
};

let scheduled = false;
const scheduleRestore = () => {
  if (scheduled) return;
  scheduled = true;
  requestAnimationFrame(() => {
    scheduled = false;
    restorePreviews();
  });
};

new MutationObserver(scheduleRestore).observe(document.body, { childList: true, subtree: true });
window.addEventListener('pageshow', scheduleRestore);
scheduleRestore();


document.addEventListener('formdata', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !event.formData) return;
  const action = new URL(form.action, window.location.href);
  if (action.origin !== window.location.origin || !/\/cart\/add(?:\.js)?\/?$/.test(action.pathname)) return;
  const data = event.formData;
  const previewIds = data.getAll('properties[thumbnail-id]');
  if (previewIds.length === 0) return;
  data.set('properties[_thumbnail-id]', previewIds[previewIds.length - 1]);
  data.delete('properties[thumbnail-id]');
}, true);
